import { BrandKitState } from './types';

const getters = {
  isBrandKitLoaded(state: BrandKitState) {
    return state.isLoaded;
  },
  getBrandKitColors(state: BrandKitState) {
    return state.colors;
  },
  getBrandKitFonts(state: BrandKitState) {
    return state.fonts;
  },
  getBrandKitBackground(state: BrandKitState) {
    return state.background;
  },
  fontsFailedToLoad(state: BrandKitState) {
    return state.fontsFailedToLoad;
  }
};

export type BrandKitGetters = {
  [k in keyof typeof getters]: ReturnType<(typeof getters)[k]>;
};

export default getters;
